<script>
import OrderbumpCheckbox from '~/components/OrderbumpCheckbox.vue';
export default {
    name: 'Orderbump',
    components: { OrderbumpCheckbox },
    computed: {
        getOrderbumps() {
            return this.$store.getters['getOrderBumps'];
        }
    },
    methods: {
        checked(e) {

            if (e.checked === false) {
                this.$store.commit('removeCartItem', e.item);
            } else {
                // this.$store.commit('setCart', e.item);
                this.$store.commit('setCartItem', e.item);
            }
            // this.$store.commit('orderbumpFromStorage', e);
        }
    },
    data() {
        return {

        }
    }
}
</script>
<template>
    <div class="overflow-hidden rounded-lg  my-2 border-orange-300 ring-1 ring-orange-300 border">
        <div class="py-3 border-b border-orange-300 leading-none px-3 bg-orange-200">
            <h3 class="text-lg font-bold leading-none text-gray-900 inline-block">Oferta Especial para levar junto!</h3>
        </div>
        <fieldset>
            <div class="relative bg-white">
                <OrderbumpCheckbox v-for="(item, index) in getOrderbumps" :key="index" :dataOrderbump="item"
                    @checked="checked" />
            </div>
        </fieldset>
    </div>
</template>
